import { render, staticRenderFns } from "./variousForms.vue?vue&type=template&id=5dc8edb0&scoped=true&"
import script from "./variousForms.vue?vue&type=script&lang=js&"
export * from "./variousForms.vue?vue&type=script&lang=js&"
import style0 from "./variousForms.vue?vue&type=style&index=0&id=5dc8edb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc8edb0",
  null
  
)

export default component.exports